<template>
  <div>
    <div class="text-xs-right">
      <v-btn small outline color="primary" flat class="ma-0" @click="convertImageRatio">
        <span class="material-icons mr-2">
          {{ ratio == 'square' ? 'crop_16_9' : 'crop_square' }}</span
        >
        {{ $t(`Resize to ${ratio == 'square' ? 'Horizontal' : 'Square'}`) }}
      </v-btn>
    </div>
    <div
      v-if="generics"
      style="overflow-x: auto; overflow-y: hidden; margin-bottom: 5px; margin-top: 15px"
    >
      <div
        style="display: flex; margin: 0; align-items: stretch; padding-bottom: 25px"
        :style="{ width: generics.length * 315 + (generics.length < 10 ? 315 : 0) + 'px' }"
      >
        <div
          v-for="(generic, index) in generics"
          :key="'generic_' + index"
          style="width: 300px; margin-right: 15px"
        >
          <generic-manage
            v-model="generics[index]"
            :vkey="index"
            :ratio="ratio"
            @onDelete="onDeleteGeneric(index)"
            @onCopy="onCopyGeneric"
          >
            <move-horizontal
              slot="move"
              :index="index"
              :max="generics.length"
              style="display: inline-block"
              @onMove="onMove(index, $event)"
            ></move-horizontal>
          </generic-manage>
        </div>

        <div
          v-if="generics.length < 10"
          style="
            position: relative;

            width: 300px;
            border: 4px dashed #eee;
            border-radius: 20px;
            cursor: pointer;
          "
          :style="{ 'min-height': ratio == 'horizontal' ? '157px' : '300px' }"
          @click="addGeneric"
        >
          <div
            style="
              position: absolute;
              left: 50%;
              top: 50%;
              margin-left: -10px;
              margin-top: -23px;
              font-size: 32px;
            "
          >
            <span class="fa fa-plus"></span>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import GenericManage from '@/components/elements/GenericManage'
import MoveHorizontal from '@/components/elements/MoveHorizontal'
import cloneDeep from 'lodash/cloneDeep'
export default {
  components: {
    GenericManage,
    MoveHorizontal
  },
  props: {
    value: {
      default: undefined
    },
    ratio: { default: 'square' }
  },
  data: function () {
    return {
      generics: undefined
    }
  },
  watch: {
    value: function (newVal) {
      this.generics = newVal
    }
  },
  mounted: function () {
    this.generics = this.value
  },
  methods: {
    onCopyGeneric(generic) {
      if (this.generics.length < 10) {
        this.generics.push(cloneDeep(generic))
      } else {
        this.$root.vtoast.show({
          message: this.$t('Generic Message cannot be more than 10 items'),
          color: 'error',
          icon: 'error'
        })
      }
    },
    convertImageRatio() {
      this.$emit('changeRatio', this.ratio == 'horizontal' ? 'square' : 'horizontal')
    },
    onDeleteGeneric(index) {
      if (this.generics.length == 1) {
        this.$emit('deleteMessage')
      } else {
        this.generics.splice(index, 1)
      }
    },
    onMove: function (index, direction) {
      var vm = this
      if (direction == 'left') {
        vm.generics.splice(index, 0, vm.generics.splice(index - 1, 1)[0])
      } else if (direction == 'right') {
        vm.generics.splice(index, 0, vm.generics.splice(index + 1, 1)[0])
      }
    },
    addGeneric: function () {
      this.generics.push({
        image_url: null,
        title: '',
        subtitle: '',
        buttons: []
        // default_action: {
        //   type: 'web_url',
        //   url: '',
        // },
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentGenericManage.vue